var auth = require('@ycgame/auth').auth;
var layer = require('layui-layer');
var dialogContent = require('./yc-dialog-user.html');
require('./yc-dialog-user.css');
require('@ycgame/icons');

var YcUserDialog = function (options) {
    this._events = $({});
    this._layerId = 0;
    this.bind = this._events.bind.bind(this._events);
    this.on = this._events.on.bind(this._events);
    this.one = this._events.one.bind(this._events);
    this.trigger = this._events.trigger.bind(this._events);
    this.$dialog = null;
    this.setOptions($.extend({}, options));
};
YcUserDialog.prototype.setOptions = function (options) {
    this.options = $.extend(this.options, options);
};

YcUserDialog.prototype._init = function () {
    if (this._inited) {
        return;
    }

    var self = this;
    var $dialog = this.$dialog = $(dialogContent);

    this._inited = true;

    $dialog.appendTo('body');
    $dialog.find('[role="yc-reg-form"]').ycRegisterForm();
    $dialog.find('[role=yc-login-form]').ycLoginForm();
    $dialog.on('error.valid', 'input:text,input:password', function (e, message) {
        layer.tips(message, $(e.target).closest('.input-group'), {tips: 2});
    }).on('error.submit', function (e, msg) {
        $('.form-msg', this).text(msg);
    });

    $dialog.on('click', '.yc-dialog-user-change-btn', function (e) {
        e.preventDefault();
        $(this).closest('.yc-dialog-user-content').toggle()
            .siblings('.yc-dialog-user-content').toggle()
            .find('input[autofocus]').focus();
    });

    $dialog.on('success.submit', function () {
        self.close();
    });

    //Submit btn loading.
    $dialog.on('submit', 'form', function () {
        var defer = $(this).data('yc-defer');
        var self = $(this);
        if (defer) {
            self.find('button[type="submit"]')
                .prop('disabled', true)
                .prepend('<span class="yc-icon yc-icon-spinner yc-spin"></span>');

            defer.always(function () {
                self.find('button[type="submit"]')
                    .prop('disabled', false)
                    .find('.yc-icon')
                    .remove();
            });
        }
    });

    this.bind('open', function () {
        $dialog.find('input[autofocus]:visible').focus();
    });

    this.trigger('init');
};
YcUserDialog.prototype.open = function () {
    var self = this;

    this._init();
    this._layerId = layer.open({
        type: 1,
        shade: 0.5,
        skin: 'yc-dialog-layer',
        title: false, //不显示标题
        content: this.$dialog, //捕获的元素，注意：最好该指定的元素要存放在body最外层，否则可能被其它的相对元素所影响
        maxWidth: 'auto',
        success: function (layero, index) {
            self.trigger('open', [layero, index]);
        }
    });
};

YcUserDialog.prototype.showVendors = function () {

    var self = this;

    var ensureApiDefer = $.Deferred();
    auth.checkLogin = function () {
        return ensureApiDefer.then(function () {
            var actApi = require('@ycgame/fetch-act-api');
            return actApi.rest('/users/me', false).get()
                .done(function (data) {
                    auth.member = data;
                    auth.trigger(auth.EVENTS.LOGIN, ['check']);
                });
        });
    };

    require.ensure(['@ycgame/fetch-act-api'], function () {
        ensureApiDefer.resolve();

        var actApi = require('@ycgame/fetch-act-api');
        var parentLogout = auth.logout;
        auth.logout = function () {
            return actApi.rest('/sessions/me')
                .del()
                .always(function () {
                    parentLogout.call(auth);
                });
        };

        $(document).on('yc.auth.success', function () {
            actApi.rest('/users/me').get().done(function (data) {
                auth.member = data;
                auth.trigger(auth.EVENTS.LOGIN, ['login']);

                self.close();
            });
        });
    });

    this.bind('init', function () {
        //Vendor click event
        var $dialog = self.$dialog;
        $dialog.on('click', '[role=yc-vendor]', function (e) {
            e.preventDefault();
            var $self = $(this);

            var w = $self.data('width');
            var h = $self.data('height');
            var authId = $self.data('auth-id');
            var url = $self.attr('href');

            var redirectSuccessUrl = location.protocol + '//' + location.host + '/auth/success.html';
            url = url.replace(
                '{redirectUrl}',
                encodeURIComponent('https://act-api.bos.ycgame.com/auth/' + authId + '?target=' + encodeURIComponent(redirectSuccessUrl))
            );

            var title = 'vendor-login';
            popupCenter(url, title, w, h);
        });

        $dialog.find('.yc-dialog-user-vendor').show();
    });
};
YcUserDialog.prototype.close = function () {
    layer.close(this._layerId);
};

function popupCenter(url, title, w, h) {
    // Fixes dual-screen position                         Most browsers      Firefox
    var dualScreenLeft = window.screenLeft != undefined ? window.screenLeft : screen.left;
    var dualScreenTop = window.screenTop != undefined ? window.screenTop : screen.top;

    var width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
    var height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;

    var left = ((width / 2) - (w / 2)) + dualScreenLeft;
    var top = ((height / 2) - (h / 2)) + dualScreenTop;
    var newWindow = window.open(url, title, 'scrollbars=yes, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left);

    // Puts focus on the newWindow
    if (window.focus) {
        newWindow.focus();
    }

    return newWindow;
}

var ycDialog = new YcUserDialog();
$(function () {
    $.ycUserDialogOpen = function (options) {
        if (options && options.showVendors) {
            ycDialog.showVendors();
        }
        ycDialog.open();
    };

    $('[role~=yc-user-dialog-open]').click(function (e) {
        e.preventDefault();
        if ($(this).data('show-vendors')) {
            ycDialog.showVendors();
        }
        ycDialog.open();
    });
});

module.exports = ycDialog;



//////////////////
// WEBPACK FOOTER
// ../node_modules/@ycgame/auth-components/src/auth-dialog/index.js
// module id = 11
// module chunks = 1